<template>
  <div class="append-box">
    <v-mask
      style="background: rgba(0, 0, 0, 0.6)"
      @touchmove="gtouchmove"
      @click="handleClose"
    ></v-mask>
    <div class="dialog-notice-box">
      <div
        v-bind:class="{
          'animated baisonFadeInDown ani-dialog-notice-box': true,
          baisonFadeInUp: fadeOut,
        }"
      >
        <div class="help-title">
          <img src="@/assets/img/help/help-title-zh.png" v-if="lang == 'cn'" />
          <img src="@/assets/img/help/help-title-en.png" v-else />
        </div>
        <div class="tag-menu-box" ref="tagMenuBox" v-if="this.multiLabel">
          <ul class="tag-menu-list">
            <li
              v-for="(item, i) in helpData"
              v-bind:class="{ 'tag-menu-item': true, selected: item.selected }"
              v-bind:key="i"
              @click="handleChangeTagMenu(item)"
              v-clickMusic
            >
              <div class="item-icon">
                <img :src="getIconSource(item.style, item.selected)" />
              </div>
              <div class="item-content">
                {{ item.title | filterTitle(lang) }}
              </div>
            </li>
          </ul>
        </div>
        <div
          v-bind:class="{ 'content-wrapper': true, 'multi-label': multiLabel }"
          ref="contentWrapper"
        >
          <div class="content" v-if="item.type == 2">
            <img :src="imgHost + item.content" @load="loadImage" />
          </div>
          <div class="content" v-html="item.content" v-else></div>
        </div>
        <btnClose
          v-bind:class="{ 'close-pop-message': true }"
          v-clickMusic
          @close="handleClose"
        ></btnClose>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import BScroll from "@better-scroll/core";
import btnClose from "@/components/btnClose.vue";
import store from "@/store/index";
import { deepClone } from "@/utils/index";
import { getHelpInfo } from "@/api/task";
export default {
  name: "dialogHelp",
  components: {
    "v-mask": vmask,
    btnClose,
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
    screenDirection() {
      return store.state.app.screenDirection;
    },
  },
  data() {
    return {
      imgHost: "https://" + store.state.app.domain.replace("gw.", "task."),
      theme: store.state.app.theme,
      lang: "cn",
      fadeOut: false,
      tabMenuIndex: 1,
      gameId: 0,
      style: 1,
      multiLabel: false,
      helpData: [],
      scrollMenu: null,
      scrollContent: null,
      item: {
        type: 1,
        title: "",
        content: "",
      },
    };
  },
  watch: {
    closeAllPopUp(val) {
      if (val.key != "dialogHelp") {
        this.remove();
      }
    },
    screenDirection() {
      this.scrollMenu && this.scrollMenu.refresh();
      this.scrollContent && this.scrollContent.refresh();
    },
  },
  mounted() {
    store.dispatch("setCloseAllPopUp", "dialogHelp");
    this.scrollContent = new BScroll(this.$refs.contentWrapper, {
      click: true,
      eventPassthrough: "horizontal",
    });
    getHelpInfo(this.gameId, this.lang).then((res) => {
      res = res.data;
      if (res.code == 0) {
        if (res.result.data && res.result.data.length > 0) {
          this.helpData = this.getHelpData(res.result.data);
          this.item = this.filterItem(res.result.data[0]);
          this.multiLabel = res.result.data.length > 1 ? true : false;
          this.$nextTick(() => {
            this.initScroller(this.multiLabel);
          });
        }
      }
    });
  },
  filters: {
    filterTitle: function (value, lang) {
      if (!value) return "";
      if (String(value).length > 4 && lang == "cn") {
        return String(value).substr(0, 4);
      } else if (String(value).length > 7 && lang == "en") {
        return String(value).substr(0, 7);
      } else {
        return value;
      }
    },
  },
  methods: {
    resetItem() {
      this.item = {
        type: 1,
        title: "",
        content: "",
      };
    },
    initScroller(isTags) {
      /**初始化滚动条 */
      if (isTags) {
        this.scrollMenu = new BScroll(this.$refs.tagMenuBox, {
          click: true,
        });
        this.scrollMenu && this.scrollMenu.refresh();
      }
      this.scrollContent && this.scrollContent.refresh();
    },
    getHelpData(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (i == 0) {
          list[i].selected = true;
        } else {
          list[i].selected = false;
        }
        arr.push(list[i]);
      }
      return arr;
    },
    getIconSource(style, selected = false) {
      let imgSource = "";
      switch (Number(style)) {
        case 1:
          /**玩法说明 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelWF_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelWF_02.png");
          }
          break;
        case 2:
          /**牌型介绍 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelPX_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelPX_02.png");
          }
          break;
        case 3:
          /**牌型大小 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelDX_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelDX_02.png");
          }
          break;
        case 4:
          /**搏一搏 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelBYB_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelBYB_02.png");
          }
          break;
        case 5:
          /**游戏宝典 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelBD_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelBD_02.png");
          }
          break;
        case 6:
          /**基本番型 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelFX_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelFX_02.png");
          }
          break;
        case 7:
          /**购买保险 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelBX_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelBX_02.png");
          }
          break;
        case 8:
          /**赔付 */
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelPF_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelPF_02.png");
          }
          break;
      }
      return imgSource;
    },
    loadImage() {
      this.scrollContent && this.scrollContent.refresh();
    },
    filterItem(item) {
      const newItem = deepClone(item);
      if (newItem.content) {
        newItem.content = String(newItem.content)
          .replaceAll(" ", "&ensp;")
          .replaceAll("\r", "<br />")
          .replaceAll("\n", "<br />");
      }
      return newItem;
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      window.__dialogHelp = null;
    },
    handleClose() {
      this.fadeOut = true;
      setTimeout(() => {
        this.remove();
        this.fadeOut = false;
        window.__dialogNotice = null;
      }, 300);
    },
    handleChangeTagMenu(item) {
      this.resetItem();
      this.$nextTick(() => {
        let list = deepClone(this.helpData);
        let showContent = {};
        for (let i = 0; i < list.length; i++) {
          if (list[i].title == item.title) {
            list[i].selected = true;
            showContent = list[i];
          } else {
            list[i].selected = false;
          }
        }
        this.helpData = list;
        this.item = this.filterItem(showContent);
        this.$nextTick(() => {
          this.scrollContent && this.scrollContent.refresh();
          this.scrollContent.scrollTo(0, 0, 0);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .dialog-notice-box {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    height: 2.68rem;
    width: 4.76rem;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/help/UI_common_help_frame_01.png) no-repeat;
      background-size: cover;
      font-size: 0.12rem;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;
      position: relative;
    }
    .help-title {
      width: 0.85rem;
      height: 0.33rem;
      position: absolute;
      left: 50%;
      top: 0.1rem;
      transform: translateX(-50%);
      img {
        width: 0.85rem;
        height: 0.33rem;
      }
    }
    .content-bg {
      width: 4.42rem;
      height: 2.02rem;
      position: absolute;
      left: 50%;
      bottom: 0.18rem;
      transform: translateX(-50%);
    }
    .tag-menu-box {
      position: absolute;
      left: 0.21rem;
      top: 0.51rem;
      width: 0.95rem;
      height: 1.965rem;
      background: url(~@/assets/img/help/UI_common_framelabelB_02.png) no-repeat;
      overflow: hidden;
      .tag-menu-list {
        .tag-menu-item {
          width: 100%;
          height: 0.42rem;
          line-height: 0.42rem;
          display: table;
          color: #709fcb;
          background: url(~@/assets/img/help/UI_common_framelabel_02.png)
            no-repeat;
          background-size: cover;
          .item-icon {
            display: table-cell;
            width: 0.38rem;
            text-align: center;
            img {
              height: 0.16rem;
              vertical-align: middle;
            }
          }
          .item-content {
            display: table-cell;
            height: 0.42rem;
            line-height: 0.42rem;
            font-size: 0.12rem;
          }
          &.selected {
            background: url(~@/assets/img/help/UI_common_framelabel_01.png)
              no-repeat;
            background-size: cover;
            .item-content {
              background-size: 0.16rem 0.16rem;
              color: #ffffff;
            }
          }
        }
      }
    }
    .content-wrapper {
      width: 4.3rem;
      height: 1.92rem;
      position: absolute;
      overflow: hidden;
      //overflow-y: scroll;
      display: block;
      left: 0.23rem;
      top: 0.53rem;
      &.multi-label {
        left: 1.2rem;
        width: 3.35rem;
      }
      .content {
        font-size: 0.1rem;
        color: #ffffff;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .close-pop-message {
      position: absolute;
      right: -0.15rem;
      top: -0.1rem;
      width: 0.35rem;
      height: 0.35rem;
      background: url(~@/assets/img/help/UI_common_button_X_01.png) no-repeat;
      background-size: cover;
    }
  }
}

@media all and (orientation: portrait) {
  .dialog-notice-box {
    transform: translate(-50%, -50%) rotate(90deg) !important;
    -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
    -moz-transform: translate(-50%, -50%) rotate(90deg) !important;
    -ms-transform: translate(-50%, -50%) rotate(90deg) !important;
    -o-transform: translate(-50%, -50%) rotate(90deg) !important;
  }
}
</style>